import { render, staticRenderFns } from "./LiquidacionForm.vue?vue&type=template&id=27fb7d32&"
import script from "./LiquidacionForm.vue?vue&type=script&lang=js&"
export * from "./LiquidacionForm.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports